import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useCompany from '../hooks/useCompany';
import CustomNavigate from '../components/CustomNavigate';

export default function EventsModuleMiddleware({ children }) {
    const { activeCompany } = useCompany();

    if (!activeCompany) return <CustomNavigate to="/dashboard/home" />;

    const modules = activeCompany?.modules || [];

    const hasEventsModule = modules.some((module) => 
        typeof module === 'string' ? module === 'event_module' : module.slug === 'event_module'
    );

    if (!hasEventsModule) return <CustomNavigate to="/dashboard/home" />;

    return children;
}

EventsModuleMiddleware.propTypes = {
    children: PropTypes.node.isRequired,
};